import { createContext } from 'react';
import { EntityBanner } from '../entities/entity-banner';
import { LinkBanner } from '../entities/link-banner';
export var defaultEntityTypeBannersSet = {
  Entity: EntityBanner,
  Link: LinkBanner
};
export var EntityTypeBannersContext = createContext(defaultEntityTypeBannersSet);
export var EntityTypeBannersProvider = EntityTypeBannersContext.Provider;